var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"mask"},[_c('div',{staticClass:"msgbox"},[_c('div',{staticClass:"msg_title"},[_vm._v("温馨提示")]),_vm._v(" "),_c('div',{staticClass:"msg_content"},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('div',{staticClass:"msg_btn",on:{"click":function($event){return _vm.close()}}},[_vm._v(_vm._s(_vm.confirmText))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a9e70ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/msgBox.vue
// module id = null
// module chunks = 